import ConfirmPaymentScreen from "./ConfirmPaymentScreen";
export default ConfirmPaymentScreen;
